import type { AgentDeployment, AgentRelease } from './types';

export function toDeploymentStatus(value: unknown): AgentDeployment['status'] {
  const normalized = String(value ?? '').toUpperCase();
  return ['DRAFT', 'DEPLOYING', 'ACTIVE', 'INACTIVE', 'ARCHIVED', 'FAILED'].includes(normalized)
    ? (normalized as AgentDeployment['status'])
    : 'DRAFT';
}

export function toReleaseStatus(value: unknown): AgentRelease['status'] {
  const normalized = String(value ?? '').toUpperCase();
  if (normalized === 'DRAFT' || normalized === 'DEPRECATED') return normalized;
  return 'PUBLISHED';
}

export function releaseDeployments(deployments: AgentDeployment[], releaseId: string) {
  return deployments.filter((deployment) => deployment.promptReleaseId === releaseId);
}

export function activeDeploymentForRelease(deployments: AgentDeployment[], releaseId: string) {
  return releaseDeployments(deployments, releaseId).find((d) => d.status === 'ACTIVE') ?? null;
}

export function currentActiveDeployment(
  deployments: AgentDeployment[],
  applicationSlug: string,
  environmentSlug: string,
) {
  return (
    deployments.find(
      (d) =>
        d.status === 'ACTIVE' &&
        d.applicationSlug === applicationSlug &&
        d.environmentSlug === environmentSlug,
    ) ?? null
  );
}

export function deploymentDefaults(
  deployments: AgentDeployment[],
  releaseId: string,
  fallbackApplicationSlug: string,
) {
  const activeForRelease = activeDeploymentForRelease(deployments, releaseId);
  const activeAny = deployments.find((d) => d.status === 'ACTIVE');
  return {
    applicationSlug:
      activeForRelease?.applicationSlug ?? activeAny?.applicationSlug ?? fallbackApplicationSlug,
    environmentSlug: activeForRelease?.environmentSlug ?? activeAny?.environmentSlug ?? 'local',
    notes: '',
  };
}
